var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToHome = function SvgToHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.82 13.82c0 .47-.351.86-.82.86H3.5c-.469 0-.82-.39-.82-.86V8H1.234c-.351 0-.546-.469-.273-.742l6.992-6.25a.83.83 0 0 1 1.094 0l6.992 6.25c.273.273.078.742-.273.742H14.32v5.82c0 .47-.351.86-.82.86H11c-.469 0-.82-.39-.82-.86V9.68H6.82z"
  })));
};
export default SvgToHome;